import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=39b178b8&scoped=true&"
import script from "./agree.vue?vue&type=script&lang=js&"
export * from "./agree.vue?vue&type=script&lang=js&"
import style0 from "./agree.vue?vue&type=style&index=0&id=39b178b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b178b8",
  null
  
)

export default component.exports